<template>
  <div>
    <table class="table-benchmarks">
    <tr>
      <th :class="item.company" :width="tableItemWidth" :key="item.name" v-for="item in selectCate">
        {{ item.name }}
      </th>
    </tr>
    <tr :key="i" v-for="(tr, i) in tableData">
      <td :class="selectCate[j].company" :key="j" v-for="(item, j) in tr">
        <template v-if="item.indexOf('@') > 0">
          <a :href="item.substr(0, item.indexOf('@'))" target="_blank">
            {{ item.substr(item.indexOf('@')+1) }}
          </a>
          <img class="h" src="../assets/hot.gif" />
        </template>
        <template v-else>
          {{ item }}
        </template>
      </td>
    </tr>
    </table>
  </div>
</template>

<script>

export default {
  name: 'GpuBenchmarksByCompany',
  props: {
    globalConfig: Object,
    selectCate: Array,
    gpuBenchmarksList: Array
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    tableItemWidth () {
      return (this.selectCate.length <= 0) ? 0 : (98 / this.selectCate.length) + '%'
    },
    selectCateName () {
      return this.selectCate.map(v => v.name)
    },
    selectCateIndex () {
      const m = {}
      for (let i = 0; i < this.selectCate.length; i++) {
        const element = this.selectCate[i]
        m[element.name] = i
      }
      return m
    },
    gpuBenchmarks () {
      const list = this.gpuBenchmarksList.map(item => item)
      list.sort((a, b) => a.g3d_i - b.g3d_i)
      return list
    },
    tableData () {
      const list = this.gpuBenchmarks.filter(v => this.selectCateName.indexOf(v.cate) >= 0)
      const res = []
      for (let i = 0; i < list.length; i++) {
        const element = list[i]
        const tr = []
        for (let j = 0; j < this.selectCate.length; j++) {
          tr[j] = ''
        }
        const key = this.selectCateIndex[element.cate]
        if (element.link && element.link.href !== '') {
          tr[key] = `${element.link.href}@${element.simple_name}\n${element.g3d_p}分`
        } else {
          tr[key] = `${element.simple_name}\n${element.g3d_p}分`
        }
        res.push(tr)
      }
      return res
    }
  }
}
</script>

<style scoped>
.Intel {
  background-color: #ddeeff;
}
.AMD {
  background-color: #ffddee;
}
.NVIDIA {
  background-color: #f0f9eb;
}
.table-benchmarks {
  border-collapse: collapse;
  width: 100%;
  margin: 1px 1px 20px 1px;
}
.table-benchmarks th {
  border-bottom: 1px solid #dddddd;
  padding: 5px 0;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.table-benchmarks td {
  border-collapse: collapse;
  border-right: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  padding: 2px 0;
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  word-break: break-all;
  white-space: pre-wrap;
}
.table-benchmarks th.Intel {
  background-color: #cce5ff;
}
.table-benchmarks th.AMD {
  background-color: #f6c8df;
}
.table-benchmarks th.NVIDIA {
  background-color: #f0f9eb;
}
.table-benchmarks td a {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}
</style>
